/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, signal} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import * as _ from 'lodash';
import template from './report-history.component.html';
import {ObjectTypeFinder} from '../common/constants/object-type';
import {ReportExecutionApiService} from './report-execution-api.service';
import {APP_SHARED} from '../common/app-shared';
import {ReportStatusComponent} from './report-status-component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, CollapseModule, ReportStatusComponent],
  selector: 'adn-report-history',
  template
})
export class ReportHistoryComponent {
  private readonly reportExecutionsState = signal<any[]>([]);
  private readonly resolvedState = signal(false);

  @Input()
  get reportExecutions(): any[] { return this.reportExecutionsState(); }
  set reportExecutions(value: any[]) { this.reportExecutionsState.set(value); }
  @Input() size: string;
  @Input() hideEmptyMessage: string;

  get resolved(): boolean { return this.resolvedState(); }
  set resolved(value: boolean) { this.resolvedState.set(value); }
  collapseExecutions = true;
  private _objType: string;
  private _objId: string;

  constructor(private readonly reportExecutionApi: ReportExecutionApiService) {
  }

  @Input()
  set objType(value: string) {
    this._objType = value;
    this.updateReportExecutions();
  }

  get objType(): string {
    return this._objType;
  }

  @Input()
  set objId(value: string) {
    this._objId = value;
    this.updateReportExecutions();
  }

  get objId(): string {
    return this._objId;
  }

  get sortedExecutions(): any[] {
    return _.orderBy(this.reportExecutions, ['executionStartTime'], ['desc']);
  }

  private setReportExecutions(reportExecutions: any[], resolved = true): void {
    this.reportExecutions = reportExecutions || [];
    this.resolved = resolved;
  }

  private updateReportExecutions(): void {
    const apiParam = _.get(ObjectTypeFinder.findByCaps(this.objType), ['apiParam']);
    if (!(this.objType && this.objId && apiParam)) {
      this.setReportExecutions([]);
      return;
    }

    this.resolved = false;
    const params: any = {};
    params[apiParam] = this.objId;
    this.reportExecutionApi.listRelated(params).subscribe({
      next: (page) => this.setReportExecutions(page.results || []),
      error: () => this.setReportExecutions([])
    });
  }
}
